import type {SafeHTMLString} from '@github-ui/safe-html'
import type {CommentAuthorAssociation} from '@github-ui/server-persisted-queries/types/IssueViewerViewQuery'
import type {Repository} from './issue-comments'
import type {LegacyTeamReviewer} from './review-requests'
import type {OrgBlockable, Reactable} from './comment-interfaces'

export type ReviewSummaryState = 'COMMENTED' | 'APPROVED' | 'CHANGES_REQUESTED' | 'DISMISSED'
export const reviewSummaryStateLabels: Record<ReviewSummaryState, string> = {
  COMMENTED: 'reviewed',
  APPROVED: 'approved',
  CHANGES_REQUESTED: 'requested changes',
  DISMISSED: 'previously reviewed',
}
export interface ReviewSummary extends OrgBlockable, Reactable {
  id: string
  relayId: string
  authorAssociation: CommentAuthorAssociation
  authorAvatarUrl: string | null
  authorLogin: string
  body: string
  bodyHtml: SafeHTMLString
  isHidden: boolean
  minimizedReason: string | null
  onBehalfOfTeams: LegacyTeamReviewer[]
  repository: Repository
  state: ReviewSummaryState
  submittedAt: string
  url: string
}

export type ReviewSummariesPayload = ReviewSummary[]
